

import React from 'react';
import { HomePageStarredEntities } from "@backstage/plugin-home";
import { Content, DocsIcon, Header, LinkButton, Page } from "@backstage/core-components";
import { HomePageSearchBar } from "@backstage/plugin-search";
import { Grid, makeStyles, Theme, ThemeProvider, Tooltip } from "@material-ui/core";
import CategoryIcon from "@material-ui/icons/Category";
import { WelcomeTitle } from "./WelcomeTitle";
import { HomePageHeader } from './HomePageHeader';

const mockupFontFamily = '"Segoe UI", Arial, sans-serif';
const homepageTheme = (theme: Theme): Theme => ({
  ...theme,
  typography: {
    ...theme.typography,
    ...Object.fromEntries(Object.entries(theme.typography).map(([name, value]) => [
      name,
      value && typeof value === 'object' && 'fontFamily' in value
        ? { ...value, fontFamily: mockupFontFamily }
        : value,
    ])),
    fontFamily: mockupFontFamily,
  },
});

const useStyles = makeStyles(theme => ({
  homepageContent: {
    fontFamily: mockupFontFamily,
  },
  starredRow: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: { padding: theme.spacing(2) },
  },
    searchBarInput: {
        maxWidth: '60vw',
        margin: 'auto',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '50px',
        boxShadow: theme.shadows[1],
    },
    searchBarOutline: {
        borderStyle: 'none'
    },
    floatingButton: {
        position: 'fixed',
        bottom: '63px',
        right: '20px',
        backgroundColor: '#05164d',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        fontSize: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
      },
      hover: {
        backgroundColor: '#05164d',
      },
}));

export const HomePage = ({ children }: React.PropsWithChildren<{}>) => {
    const classes = useStyles();

    const navigateToBoard=()=>{
        return window.open("https://dev.azure.com/lhg-ddl/CoP-DevSecOps-Engineering/_workitems/create/Product%20Backlog%20Item?templateId=3460b89b-06c3-4e60-bf8c-8adbb26c8b1c&ownerId=61ea317b-b78a-409d-bd50-d01d422c2d30&[System.Tags]=dh-dock","__blank")
    }
  
    const FloatingButton = () => {
        
        return (
            <Tooltip title="Submit a Feature Request" arrow>
            
            <button className={`${classes.floatingButton} ${classes.hover}`} onClick={navigateToBoard}>
            +
          </button>
          </Tooltip>
        );
      };
      
    
    return (
      <ThemeProvider theme={children ? homepageTheme : theme => theme}>
      <Page themeId="home">
        {children ? <HomePageHeader /> : (
          <Header title={<WelcomeTitle />} pageTitleOverride="Home" />
        )}
        <Content className={children ? classes.homepageContent : undefined}>
          <Grid
            container
            className={children ? classes.starredRow : undefined}
            justifyContent="center"
            spacing={children ? 0 : 3}
            style={{ minHeight: children ? undefined : '100vh' }}
          >
            {!children && <Grid
              container
              item
              xs={12}
              alignItems="center"
              justifyContent="center"
            >
              <LinkButton
                startIcon={<DocsIcon />}
                size="large"
                variant="contained"
                color="primary"
                style={{ margin: '1rem' }}
                to="/docs/default/System/be26df2f-284c-f011-877a-7c1e527224bf/tutorials/onboarding/"
              >
                Get Onboarded to DH-Dock
              </LinkButton>
              <LinkButton
                startIcon={<CategoryIcon />}
                size="large"
                variant="outlined"
                style={{ margin: '1rem' }}
                to="/docs/default/System/be26df2f-284c-f011-877a-7c1e527224bf"
              >
                Read the DH-Dock Docs
              </LinkButton>
            </Grid>}
            {!children && <Grid item xs={12}>
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>}
            <Grid item xs={12} md={children ? 12 : 6}>
              <HomePageStarredEntities />
            </Grid>
          </Grid>
          {children}
          <FloatingButton />
        </Content>
      </Page>
      </ThemeProvider>
    );
};